import React, { FC } from 'react'
import { Box, Button, MenuButton } from '@chakra-ui/react'
import { Icon } from '../icon'

export interface DropdownButtonProps {
  label: string
  stretch?: boolean
}

export const DropdownButton: FC<DropdownButtonProps> = ({ label }) => (
  <MenuButton
    as={Button}
    rightIcon={
      <Box>
        <Icon icon="chevron-down" color="green.500" />
      </Box>
    }
    borderRadius="medium"
    fontWeight="normal"
    fontSize={18}
    border={2}
    borderStyle="solid"
    borderColor="grey"
    width={240}
    role="combobox"
    height={50}
    textAlign="left"
    color="black"
    backgroundColor="white"
    _hover={{
      borderColor: 'brand',
      boxShadow: '0 0 0 3px #5bce4c',
    }}
    sx={{
      '> span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }}
    _focus={{
      borderColor: 'brand',
      boxShadow: '0 0 0 2px #5bce4c',
    }}
    tabIndex={0}
    aria-label={`button-${label}`}
  >
    {label}
  </MenuButton>
)
